import React, {useState, useEffect} from 'react';

import { storage } from '../../firebase';
import * as CONFIG from 'constants/config';

import Select from 'components/Select';

import { updateSubcategory, updateSubcategoryImage } from 'backend/Subcategory';

const SubcategoryItem = ({subcategory, index, categoryNameRu, categories, currentPage}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isFree, setIsFree] = useState(subcategory.isFree);
  const [categoryName, setCategoryName] = useState(categoryNameRu);
  const [categoryUid, setCategoryUid] = useState(subcategory.categoryUid);
  const [localIsFree, setLocalIsFree] = useState(subcategory.isFree);

  const [nameEn, setNameEn] = useState(subcategory.name.en);
  const [nameRu, setNameRu] = useState(subcategory.name.ru);
  const [nameUk, setNameUk] = useState(subcategory.name.uk);
  const [namePl, setNamePl] = useState(subcategory.name.pl);
  const [nameIt, setNameIt] = useState(subcategory.name.it);
  const [nameEs, setNameEs] = useState(subcategory.name.es);
  const [namePt, setNamePt] = useState(subcategory.name.pt);

  const [leadEn, setLeadEn] = useState(subcategory.lead.en);
  const [leadRu, setLeadRu] = useState(subcategory.lead.ru);
  const [leadUk, setLeadUk] = useState(subcategory.lead.uk);
  const [leadPl, setLeadPl] = useState(subcategory.lead.pl);
  const [leadIt, setLeadIt] = useState(subcategory.lead.it);
  const [leadEs, setLeadEs] = useState(subcategory.lead.es);
  const [leadPt, setLeadPt] = useState(subcategory.lead.pt);

  const [localNameEn, setLocalNameEn] = useState(subcategory.name.en);
  const [localNameRu, setLocalNameRu] = useState(subcategory.name.ru);
  const [localNameUk, setLocalNameUk] = useState(subcategory.name.uk);
  const [localNamePl, setLocalNamePl] = useState(subcategory.name.pl);
  const [localNameIt, setLocalNameIt] = useState(subcategory.name.it);
  const [localNameEs, setLocalNameEs] = useState(subcategory.name.es);
  const [localNamePt, setLocalNamePt] = useState(subcategory.name.pt);

  const [localLeadEn, setLocalLeadEn] = useState(subcategory.lead.en);
  const [localLeadRu, setLocalLeadRu] = useState(subcategory.lead.ru);
  const [localLeadUk, setLocalLeadUk] = useState(subcategory.lead.uk);
  const [localLeadPl, setLocalLeadPl] = useState(subcategory.lead.pl);
  const [localLeadIt, setLocalLeadIt] = useState(subcategory.lead.it);
  const [localLeadEs, setLocalLeadEs] = useState(subcategory.lead.es);
  const [localLeadPt, setLocalLeadPt] = useState(subcategory.lead.pt);

  const [image, setImage] = useState(null);
  const [url, setUrl] = useState(subcategory.image);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setIsFree(subcategory.isFree);
    setLocalIsFree(subcategory.isFree);
    setCategoryName(categoryNameRu);
    setCategoryUid(subcategory.categoryUid);
    setNameEn(subcategory.name.en);
    setNameRu(subcategory.name.ru);
    setNameUk(subcategory.name.uk);
    setNamePl(subcategory.name.pl);
    setNameIt(subcategory.name.it);
    setNameEs(subcategory.name.es);
    setNamePt(subcategory.name.pt);

    setLocalNameEn(subcategory.name.en);
    setLocalNameRu(subcategory.name.ru);
    setLocalNameUk(subcategory.name.uk);
    setLocalNamePl(subcategory.name.pl);
    setLocalNameIt(subcategory.name.it);
    setLocalNameEs(subcategory.name.es);
    setLocalNamePt(subcategory.name.pt);

    setUrl(subcategory.image);
  }, [categoryNameRu, subcategory]);

  const handleChange = (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      setImage(image);
    }
  };

  const handleUpload = (id) => {
    const uploadTask = storage.ref(`subcategory/${image.name}`).put(image);
    uploadTask.on(
      "state_changed",
      snapshot => {
        // progress function ...
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(progress);
      },
      error => {
        // Error function ...
        console.log(error);
      },
      () => {
        storage
          .ref("subcategory")
          .child(image.name)
          .getDownloadURL()
          .then((urlResult) => {
            //delete old image
            if (subcategory.image) {
              storage.refFromURL(subcategory.image).delete();
            }
            updateSubcategoryImage(id, urlResult);
            setUrl(urlResult);
          });
      }
    );
  };

  const onClickDelete = (id) => {
    alert('TODO: step 2');
  };

  const onClickEdit = () => {
    setIsEdit(!isEdit);
  };

  const onClickSave = (id) => {
    setProgress(0);
    updateSubcategory(
      id,
      isFree,
      categoryUid,
      nameEn,
      nameRu,
      nameUk,
      namePl,
      nameIt,
      nameEs,
      namePt,
      leadEn,
      leadRu,
      leadUk,
      leadPl,
      leadIt,
      leadEs,
      leadPt,
      url)
      .then(() => {
        setIsEdit(false);
        setLocalIsFree(isFree);
        setLocalNameEn(nameEn);
        setLocalLeadEn(leadEn);

        setLocalNameRu(nameRu);
        setLocalLeadRu(leadRu);

        setLocalNameUk(nameUk);
        setLocalLeadUk(leadUk);

        setLocalNamePl(namePl);
        setLocalLeadPl(leadPl);

        setLocalNameIt(nameIt);
        setLocalLeadIt(leadIt);

        setLocalNameEs(nameEs);
        setLocalLeadEs(leadEs);

        setLocalNamePt(namePt);
        setLocalLeadPt(leadPt);
      })
      .catch((error) => {
        console.log('updateSubcategory error', error);
      });
  };

  const onClickCancel = () => {
    setIsEdit(false);
    setNameEn(localNameEn);
    setLeadEn(localLeadEn);

    setNameRu(localNameRu);
    setLeadRu(localLeadRu);

    setNameUk(localNameUk);
    setLeadUk(localLeadUk);

    setNamePl(localNamePl);
    setLeadPl(localLeadPl);

    setNameIt(localNameIt);
    setLeadIt(localLeadIt);

    setNameEs(localNameEs);
    setLeadEs(localLeadEs);

    setNamePt(localNamePt);
    setLeadPt(localLeadPt);
    setProgress(0);
  };

  const onChangeText = (event, field) => {
    if (field === 'nameEn') setNameEn(event.target.value);
    if (field === 'nameRu') setNameRu(event.target.value);
    if (field === 'nameUk') setNameUk(event.target.value);
    if (field === 'namePl') setNamePl(event.target.value);
    if (field === 'nameIt') setNameIt(event.target.value);
    if (field === 'nameEs') setNameEs(event.target.value);
    if (field === 'namePt') setNamePt(event.target.value);

    if (field === 'leadEn') setLeadEn(event.target.value);
    if (field === 'leadRu') setLeadRu(event.target.value);
    if (field === 'leadUk') setLeadUk(event.target.value);
    if (field === 'leadPl') setLeadPl(event.target.value);
    if (field === 'leadIt') setLeadIt(event.target.value);
    if (field === 'leadEs') setLeadEs(event.target.value);
    if (field === 'leadPt') setLeadPt(event.target.value);
  };

  const selectCategory = (event) => {
    setCategoryUid(event.target.value);
    setCategoryName(event.target.options[event.target.selectedIndex].text);
  };

  const checkboxOnChange = (value) => {
    setIsFree(!isFree);
  };

  const num = (index + 1) + ((currentPage - 1) * CONFIG.COUNT_PER_PAGE);

	return (
		<tr style={{backgroundColor: isEdit ? '#EEF4F9' : ''}}>
      <td>{num}</td>
      <td>
        {subcategory.alias}
        <br />
        {localIsFree && !isEdit ? (<span className="label label-success arrowed">Бесплатно</span>) : null}
        {isEdit ? (
          <label>
            <input name="switch-field-1" className="ace ace-switch" type="checkbox" value={true} onChange={(value) => checkboxOnChange(value)} checked={isFree}  />
            <span className="lbl" data-lbl="FREE        PAY"></span>
          </label>
        ) : null}
      </td>
      <td>
        {isEdit ? (
          <Select items={categories} placeholder="Категории" onChange={(event) => selectCategory(event)} selectedValue={categoryUid} index={index} />         
        ) : categoryName}
      </td>
      <td align="center" style={{backgroundColor: '#D8D8D8'}}>
        {url && !isEdit ? (<img src={url} alt={subcategory.alias} width="50" />) : null}
        {isEdit ? (
          <div>
            <progress value={progress} max="100" className="progress" />
            <br />
            <label className="ace-file-input">
              <input type="file" id="id-input-file-2" onChange={(e) => handleChange(e)} />
              <span className="ace-file-container" data-title="Choose">
                <span className="ace-file-name" data-title="No File ...">
                  <i className=" ace-icon fa fa-upload"></i>
                </span>
              </span>
              <a className="remove" href="#">
                <i className=" ace-icon fa fa-times"></i>
              </a>
            </label>
            <button type="button" className="btn btn-sm btn-success" onClick={() => handleUpload(subcategory.alias)}>
              Загрузить
						  <i className="ace-icon fa fa-upload icon-on-right bigger-110"></i>
						</button>
            <br />
            <br />
            {url ? ( <img src={url} alt="Uploaded Image" width="50" />) : null}
          </div>
        ) : null}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameEn-' + index}
              placeholder="Название категории (EN)"
              value={nameEn}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameEn')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadEn-' + index}
              placeholder="Описание категории (EN)"
              value={leadEn}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadEn')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameEn}</b>
            <br/>
            {localLeadEn}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameRu-' + index}
              placeholder="Название категории (RU)"
              value={nameRu}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameRu')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadRu-' + index}
              placeholder="Описание категории (RU)"
              value={leadRu}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadRu')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameRu}</b>
            <br/>
            {localLeadRu}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameUk-' + index}
              placeholder="Название категории (UK)"
              value={nameUk}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameUk')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadUk-' + index}
              placeholder="Описание категории (UK)"
              value={leadUk}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadUk')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameUk}</b>
            <br/>
            {localLeadUk}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameIt-' + index}
              placeholder="Название категории (IT)"
              value={nameIt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameIt')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadIt-' + index}
              placeholder="Описание категории (IT)"
              value={leadIt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadIt')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameIt}</b>
            <br/>
            {localLeadIt}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-namePl-' + index}
              placeholder="Название категории (PL)"
              value={namePl}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'namePl')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadPl-' + index}
              placeholder="Описание категории (PL)"
              value={leadPl}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadPl')}
            />
          </div>
        ) : (
          <div>
            <b>{localNamePl}</b>
            <br/>
            {localLeadPl}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-nameEs-' + index}
              placeholder="Название категории (ES)"
              value={nameEs}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'nameEs')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadEs-' + index}
              placeholder="Описание категории (ES)"
              value={leadEs}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadEs')}
            />
          </div>
        ) : (
          <div>
            <b>{localNameEs}</b>
            <br/>
            {localLeadEs}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <div>
            <input
              type="text"
              id={'form-namePt-' + index}
              placeholder="Название категории (PT)"
              value={namePt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'namePt')}
            />
            <br/><br/>
            <input
              type="text"
              id={'form-leadPt-' + index}
              placeholder="Описание категории (PT)"
              value={leadPt}
              className="col-xs-12 col-sm-12"
              onChange={(event) => onChangeText(event, 'leadPt')}
            />
          </div>
        ) : (
          <div>
            <b>{localNamePt}</b>
            <br/>
            {localLeadPt}
          </div>
        )}
      </td>
      <td>
        {isEdit ? (
          <p>
            <button className="btn btn-success btn-xs" onClick={() => onClickSave(subcategory.alias)}>
              <i className="ace-icon fa fa-save bigger-110 icon-only"></i>
            </button>
            &nbsp;&nbsp;
            <button className="btn btn-grey btn-xs" onClick={() => onClickCancel()}>
              <i className="ace-icon fa fa-reply bigger-110 icon-only"></i>
            </button>
          </p>
        ) : (
          <p>
            <button className="btn btn-warning btn-xs" onClick={() => onClickEdit()}>
              <i className="ace-icon fa fa-pencil-square-o bigger-110 icon-only"></i>
            </button>
            &nbsp;&nbsp;
            <button className="btn btn-grey btn-xs" onClick={() => onClickDelete(subcategory.alias)}>
              <i className="ace-icon fa fa-trash-o bigger-110 icon-only"></i>
            </button>
          </p>
        )}
      </td>
		</tr>
	);
};

export default SubcategoryItem;
